import { get } from 'lodash';

import { AppState } from 'Interfaces/Interfaces';

const root = (state: AppState) => get(state, 'loadersState');

export const getPageLoaderActive = (state: AppState) => get(root(state), 'pageLoaderActive', true);
export const getModalOpen = (state: AppState) => get(root(state), 'modalOpen', true);
export const getComponentLoaderActive = (state: AppState) => get(root(state), 'componentLoaderActive', true);
